import { NotifyHelper } from "../../../helpers/toast";
import { eTongHopKyActionsObj } from "../../action-types/tong-hop-diem/ITongHopKyActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tongHopKyActions = {
    ...generateActions(eTongHopKyActionsObj, "TONG_HOP_KY"),
    ...generateActionForKey(eTongHopKyActionsObj, "TONG_HOP_KY", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    })
}